module.exports = __webpack_public_path__ + "static/media/terms.8275dab7.svg";